import { useEffect } from 'react'

/**
 * Route Log
 */
const useRouteLog = (
  path: string
): any => {

  useEffect(() => {
    console.log(`routes: ${path} mounted`)
    return () => {
      console.log(`routes: ${path} unmounted`)
    }
  }, [path])

  return null
}

export default useRouteLog
